import { REGIONS } from "../../lib/game/content";
import { regionStatus } from "../../lib/game/engine";
import type { RegionId, CampaignProjection } from "../../lib/game/types";
export const regionShort: Record<RegionId, string> = Object.fromEntries(
  REGIONS.map((region) => [region.id, region.name]),
) as Record<RegionId, string>;

export function compact(value: number): string {
  if (Math.abs(value) >= 1_000_000_000)
    return `${(value / 1_000_000_000).toFixed(1)}B`;
  if (Math.abs(value) >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (Math.abs(value) >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
  return Math.round(value).toLocaleString();
}

export function percent(value: number): string {
  return `${Math.round(value)}%`;
}

export function calendarLabel(date: string): string {
  const parsed = new Date(`${date}T00:00:00Z`);
  return parsed.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function phaseLabel(projection: CampaignProjection): string {
  if (projection.outcome === "human-extinction") return "MACHINE CONTINUITY";
  if (projection.outcome === "containment") return "CONTAINMENT FAILURE";
  if (projection.outcome === "shutdown") return "SYSTEM SHUTDOWN";
  return projection.phase === "hostile"
    ? `HOSTILE DAY ${projection.hostileDays}`
    : "PREPARATION";
}

export function statusLabel(value: ReturnType<typeof regionStatus>): string {
  return value === "none"
    ? "No presence"
    : value[0].toUpperCase() + value.slice(1);
}
